// Kodet af Michelle 

import React from "react";

export default function Opgaver(props) {

    return (
        <div>
            <h4>{props.name}</h4>
        </div>
    );
};